export const TRADE_TUTORIAL_LINK = 'https://www.youtube.com/playlist?list=PL6OBDgmGm90AFHxCcAyJvn-aB3oOBafOD';
export const FAQ_LINKS = {
  PREDICTED_FUNDING_RATE: 'https://docs.synfutures.com/oyster-amm/funding-for-perpetual-futures#advanced',
  LIQUIDATION_PRICE: 'https://docs.synfutures.com/oyster-amm/liquidations',
  APPROVE_FAQ: 'https://docs.synfutures.com/faq/others',
  PNL_FAQ: '',
  POOL_LIST_FAQ: 'https://www.synfutures.com/v3-whitepaper.pdf',
  TUTORIAL_FAQ: 'https://docs.synfutures.com/tutorials/video-tutorial',
  FAQ: 'https://docs.synfutures.com/faq/synfutures-v3-features',
  WITHDRAW_LIMIT: 'https://docs.synfutures.com/oyster-amm/position-and-margin#margin-deposit-and-withdraw',
  COMMUNITY_DOC: 'https://docs.synfutures.com/oyster-amm/pair-specifications/blast-network#community-listing',
  COMMUNITY_BASE_DOC: 'https://docs.synfutures.com/oyster-amm/pair-specifications/base-network#community-listing',
};
export const LEVERAGE_LINK = '';

export const SOCIAL_LINKS = {
  TWITTER: 'https://twitter.com/SynFuturesDefi',
  TELEGRAM: 'https://t.me/synfutures_Defi',
  DISCORD: 'https://discord.com/invite/synfutures',
  REDDIT: 'https://www.reddit.com/r/SynFutures',
};

export const AUDIT_LINK = 'https://www.synfutures.com/Quantstamp-Audit-Report-SynFuturesV3.pdf';

export const INFO_LINK = 'https://info.synfutures.com';

export const LEARN_MORE_LINK = {
  socialLoss: 'https://docs.synfutures.com/oyster-amm/liquidations',
  oi: 'https://docs.synfutures.com/oyster-amm/position-and-margin#open-interests',
};
export const ADDITIONAL_FEE_LINK = 'https://docs.synfutures.com/oyster-amm/security#dynamic-penalty-fees';

export const SHARE_POST_UPLOAD = 'https://api.synfutures.com/v3/public/share/twitter';
export const SHARE_GET = 'https://api.synfutures.com/v3/public/share/twitter/link?id=';
export const TVL_JOIN_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSdth8V4lXstrlGCRuTWJIWY1QNJ_slpwSfgdlHaN8KYipmQrw/viewform?usp=sharing';

export const FARCASTER_LINK = `https://api.synfutures.com/v3/farcaster`;

export const FARCASTER_SHARE_LINK = 'https://warpcast.com/~/compose?text=';

export const LAUNCHPAD_LINK = 'https://launchpad.synfutures.com/';
